<div class="logo">
  <img class="logo__image" src="/assets/logo.svg" alt="FrontForce">
  <div class="logo__text">
    <h5>FrontForce</h5>
    <small>Emergency</small>
  </div>
</div>
